import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Settings } from "@core/store/settings/settings.model";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MatDialogRef } from "@angular/material";

@Component({
  selector: "report-email-settings",
  templateUrl: "./report-email-settings.component.html",
  styleUrls: ["./report-email-settings.component.scss"],
})
export class ReportEmailSettingsComponent implements OnInit {
  form: FormGroup;

  @Input() settings: Settings;
  @Output() saved = new EventEmitter<Settings>();

  constructor(
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<ReportEmailSettingsComponent>,
  ) {}

  ngOnInit() {
    this.form = this.formBuilder.group({
      reportEmailSubject: this.settings.reportEmailSubject,
      reportEmailContent: this.settings.reportEmailContent,
    });
  }

  submitChanges(value) {
    this.saved.emit(Object.assign({}, this.settings, value));
    this.closeDialog();
  }

  closeDialog() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// /app/src/app/settings/components/report-email-settings/report-email-settings.component.ts